import { MfaMethod, MfaMethodType } from 'src/api/mfa';

export const MFA_METHOD_LABELS: { [key in MfaMethodType]: string } = {
    email: 'Email',
    sms: 'Text message',
    totp: 'Authenticator app',
};

export const MFA_METHOD_SECURITY_ORDER: MfaMethodType[] = ['totp', 'sms', 'email'];

export function normalizeMfaMethodType(methodType?: string): MfaMethodType | null {
    const normalized = (methodType || '').toLowerCase();
    return normalized === 'email' || normalized === 'sms' || normalized === 'totp'
        ? (normalized as MfaMethodType)
        : null;
}

export function sortMfaMethodTypesBySecurity(methodTypes: MfaMethodType[]) {
    return [...methodTypes].sort(
        (a, b) => MFA_METHOD_SECURITY_ORDER.indexOf(a) - MFA_METHOD_SECURITY_ORDER.indexOf(b),
    );
}

export function getVerifiedMfaMethod(methods: MfaMethod[], methodType: MfaMethodType) {
    return getVerifiedMfaMethods(methods, methodType)[0];
}

export function getVerifiedMfaMethods(methods: MfaMethod[], methodType: MfaMethodType) {
    return methods.filter(
        (method) =>
            normalizeMfaMethodType(method.mfaMethodTyp) === methodType &&
            method.verifiedInd &&
            method.actvInd !== false,
    );
}
